import { IconButton, Paper, Select, styled, Typography } from '@mui/material';

// Styled components
const ZoomControlContainer = styled(Paper)(({ theme }) => ({

  padding: theme.spacing(1.5, 2),
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  backgroundColor: theme.palette.background.paper,
  boxShadow: theme.shadows[4],
  borderRadius: theme.spacing(1),
  minWidth: 200,
}));
  
const ZoomSelect = styled(Select)(({ theme }) => ({
  minWidth: 100,
  height: 32,
  '& .MuiSelect-select': {
    padding: theme.spacing(0.5, 1),
    fontSize: '0.875rem',
  },
}));
  
const ZoomPercentage = styled(Typography)(({ theme }) => ({
  fontSize: '0.75rem',
  fontWeight: 500,
  minWidth: 35,
  textAlign: 'center',
  color: theme.palette.text.secondary,
}));
  
const ZoomIconButton = styled(IconButton)(({ theme }) => ({
  padding: theme.spacing(0.5),
  '& .MuiSvgIcon-root': {
    fontSize: '1rem',
  },
}));

export { ZoomControlContainer, ZoomSelect, ZoomPercentage, ZoomIconButton };